import * as net from '../net';

const InventoryDAO = {};

InventoryDAO.get_inventory = (comment_id) => net.get({url: '/api/inventory'})

InventoryDAO.add_item_to_inventory = (data) => net.post({url: '/api/inventory/register-item', data})

export default InventoryDAO;
